// extracted by mini-css-extract-plugin
var _1 = "DocFlowFormFilesField-modulefiles__RL5PP FileList-moduleFileList__c_gL2";
export { _1 as "files" }
